import { Translation } from './pt-BR'

const messages: Translation = {
  filter: {
    apply: 'Apply',
    cleanFilters: 'Clear filters',
    filter: 'Filters',
    clean: 'Clear',
    price: 'Price',
    to: 'to',
    currency: '$',
    sort: {
      title: 'Sort',
      newest: 'Newest',
      oldest: 'Oldest',
      lowest: 'Lowest price',
      highest: 'Highest price',
      az: 'Alphabetical',
      za: 'Reverse alphabetical'
    },
    displayModeError: 'The chosen display mode is not valid!',
    search: {
      placeholder: 'Type in your search',
      cta: 'Press enter'
    }
  }
}

export { messages }
